import { useCallback } from 'react';

import { env } from '@/config/env';
import { createLink } from '@/helpers/links/createLink';

import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { useLocalStorage } from '@/hooks/useLocalStorage';

interface CreateGamezoneUrlParams {
  pathname?: string;
  searchParams?: Record<string, string>;
}

export const useGamezone = () => {
  const { value: lang } = useLocalStorage<string>(StorageKeysEnum.i18nextLng);
  const { value: clientToken } = useLocalStorage<string>(
    StorageKeysEnum.clientToken || '',
  );

  const createGamezoneUrl = useCallback(
    (props?: CreateGamezoneUrlParams) => {
      const { pathname, searchParams } = props || {};

      return createLink({
        url: env.GAMEZONE_URL,
        pathname,
        searchParams: {
          token: clientToken,
          lang,
          ...searchParams,
        },
      });
    },
    [lang, clientToken],
  );

  return { createGamezoneUrl };
};
